/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Ticker_Airspace_PrefixInputs */

const bn_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আকাশপথ`)
};

const de_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LUFTRAUM`)
};

const el_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`εναέριος χώρος`)
};

const en_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIRSPACE`)
};

const es_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESPACIO AÉREO`)
};

const fr_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESPACE AÉRIEN`)
};

const hi_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हवाई क्षेत्र`)
};

const hu_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LÉGTÉR`)
};

const id_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RUANG UDARA`)
};

const it_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPAZIO AEREO`)
};

const ja_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空域`)
};

const ko_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공적`)
};

const nl_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LUCHTRUIM`)
};

const pl_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KUBATURA`)
};

const pt_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESPAÇO AÉREO`)
};

const ru_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ВОЗДУШНОЕ ПРОСТРАНСТВО`)
};

const sv_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LUFTRUM`)
};

const tr_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HAVA SAHASI`)
};

const uk_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПОВІТРЯНИЙ ПРОСТІР`)
};

const vi_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VŨ TRỤ`)
};

const zh_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空域`)
};

const zh_hant_cipher_ticker_airspace_prefix = /** @type {(inputs: Cipher_Ticker_Airspace_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空域`)
};

/**
* | output |
* | --- |
* | "AIRSPACE" |
*
* @param {Cipher_Ticker_Airspace_PrefixInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_ticker_airspace_prefix = /** @type {((inputs?: Cipher_Ticker_Airspace_PrefixInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Ticker_Airspace_PrefixInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_ticker_airspace_prefix(inputs)
	if (locale === "de") return de_cipher_ticker_airspace_prefix(inputs)
	if (locale === "el") return el_cipher_ticker_airspace_prefix(inputs)
	if (locale === "en") return en_cipher_ticker_airspace_prefix(inputs)
	if (locale === "es") return es_cipher_ticker_airspace_prefix(inputs)
	if (locale === "fr") return fr_cipher_ticker_airspace_prefix(inputs)
	if (locale === "hi") return hi_cipher_ticker_airspace_prefix(inputs)
	if (locale === "hu") return hu_cipher_ticker_airspace_prefix(inputs)
	if (locale === "id") return id_cipher_ticker_airspace_prefix(inputs)
	if (locale === "it") return it_cipher_ticker_airspace_prefix(inputs)
	if (locale === "ja") return ja_cipher_ticker_airspace_prefix(inputs)
	if (locale === "ko") return ko_cipher_ticker_airspace_prefix(inputs)
	if (locale === "nl") return nl_cipher_ticker_airspace_prefix(inputs)
	if (locale === "pl") return pl_cipher_ticker_airspace_prefix(inputs)
	if (locale === "pt") return pt_cipher_ticker_airspace_prefix(inputs)
	if (locale === "ru") return ru_cipher_ticker_airspace_prefix(inputs)
	if (locale === "sv") return sv_cipher_ticker_airspace_prefix(inputs)
	if (locale === "tr") return tr_cipher_ticker_airspace_prefix(inputs)
	if (locale === "uk") return uk_cipher_ticker_airspace_prefix(inputs)
	if (locale === "vi") return vi_cipher_ticker_airspace_prefix(inputs)
	if (locale === "zh") return zh_cipher_ticker_airspace_prefix(inputs)
	return zh_hant_cipher_ticker_airspace_prefix(inputs)
});